import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  get(params) {
    const url = apiRoutes.searchIndexPath(1, params);
    return FetchHelpers.get(url);
  },
};
